<template>
	<div v-if="page" class="max-w-full">
		<slot name="top">
			<nk-carousel
				v-if="shuffledHeroImages?.length || defaultHeroImages?.length"
				variant="hero-slim"
				ariaLabel="Durchlaufende Bilder"
			>
				<template v-if="shuffledHeroImages">
					<nk-carousel-slide
						v-for="(heroImage, heroImageIndex) in shuffledHeroImages"
						:key="`heroImage-${heroImageIndex}`"
						:bg-image="heroImage.src"
						:bg-image-alt="heroImage.alt"
						:bg-image-copyright="heroImage.copyright"
						bg-image-copyright-position="left top"
					/>
				</template>
				<template v-else-if="defaultHeroImages">
					<nk-carousel-slide
						v-for="(defaultImage, defaultImageIndex) in defaultHeroImages"
						:key="`defaultImage-${defaultImageIndex}`"
						:bg-image="`/static-images/${defaultImage}`"
					/>
				</template>
			</nk-carousel>
			<nk-breadcrumb
				:breadcrumbs="page.breadcrumbs"
				:home-path="homePath"
				:home-title="homeTitle"
			/>
		</slot>

		<NkWrapper v-if="page.isLoading && !page.isQueryOnlyChanging" spacing="xl">
			<NkLoader color="primary" />
		</NkWrapper>
		<div v-else class="container mx-auto px-6">
			<nk-wrapper spacing="lg">
				<div
					data-sticky-container
					class="grid grid-cols-1 xl:grid-cols-12 xl:gap-16 2xl:gap-24"
				>
					<div
						:class="{
							'xl:col-span-10': emptySidebar && $slots.sidebar === undefined,
							'xl:col-span-8': !emptySidebar || $slots.sidebar !== undefined,
						}"
					>
						<NkWrapper
							v-if="page.isLoading && page.isQueryOnlyChanging"
							spacing="xl"
						>
							<NkLoader color="primary" />
						</NkWrapper>
						<main v-else>
							<slot name="content">
								<template
									v-for="(module, indexModuleContent) in page.context.filter(
										module =>
											module.slotName === 'content' ||
											typeof module.slotName === 'undefined',
									)"
									:key="indexModuleContent"
								>
									<component
										v-bind="{
											context: module.context,
											options: module.options,
										}"
										:is="componentName(module.template)"
									/>
								</template>
							</slot>
						</main>
					</div>
					<div
						v-if="!emptySidebar || $slots.sidebar !== undefined"
						class="xl:col-span-4 xl:-mr-[calc((100vw-1280px)/2+1.5rem)] 2xl:-mr-[calc((100vw-1440px)/2+1.5rem)]"
					>
						<img
							src="/static-images/decorative/sidebar-circles.svg"
							alt=""
							class="max-w-[480px] pl-6"
						/>
						<div class="p-6 bg-white shadow-lg rounded-l-xl">
							<nk-sidebar>
								<slot name="sidebar">
									<template
										v-for="(module, indexModuleSidebar) in page.context.filter(
											module => module.slotName === 'sidebar',
										)"
										:key="indexModuleSidebar"
									>
										<component
											v-bind="{
												context: module.context,
												options: module.options,
											}"
											:is="componentName(module.template)"
										/>
									</template>
								</slot>
							</nk-sidebar>
						</div>
					</div>
				</div>
			</nk-wrapper>
		</div>
		<slot name="bottom" />
	</div>
</template>

<script>
import {useCMS} from '#nk/composables/cms';
import pageLayout from '#nk/mixins/page-layout';

export default {
	name: 'NkPageDefault',

	mixins: [pageLayout],

	props: {
		homePath: {
			type: String,
			required: false,
			default: '/',
		},
		homeTitle: {
			type: String,
			required: false,
			default: 'Startseite',
		},
	},

	setup() {
		const page = useCMS();

		return {
			page,
		};
	},
};
</script>
